/**
 * Returns if the strings a and b match each other while respeting accent variations and ignoring casing differences
 */
export const matchesCaseInsensitive = (a: string, b: string, locale = "en") =>
  a.localeCompare(b, locale, { sensitivity: "accent" }) === 0;
